import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => ({
      hasAgreedToDataPolicy: false,
  }),
  actions: {
    agreedToDataPolicy() {
      this.hasAgreedToDataPolicy = true;
    },
    clear() {
      this.hasAgreedToDataPolicy = false;
    },

  },
})